import { SearchbarHistoryItem } from '../../../redux/searchbar/types'
import { useTranslation } from '../../../hooks/locale'
import { historyDateDisplay } from '../../../utils/miscellaneous-utils'

export const useRecentSearchCard = (historyItem: SearchbarHistoryItem) => {
    const { t } = useTranslation()
    const { search, arrival, departure, adults, children } = historyItem

    const adultsLabel = adults > 0 ? `${adults} ${t('adultsGuest')}` : ''
    const childrenLabel = children > 0 ? `${children} ${t('childrenGuest')}` : ''
    const guestsLabel = [adultsLabel, childrenLabel].filter(Boolean).join(' · ')
    const dateDisplay = !arrival || !departure ? t('flexiblePeriod') : historyDateDisplay(arrival, departure)

    return {
        destination: search,
        details: dateDisplay,
        guestsLabel,
    }
}
